import React from 'react'
import { FooterSmall, SEO, Signup } from 'newComponents'
import Layout from '../components/layout'

const StartTrial = () => (
  <Layout footer={false}>
    <SEO
      title="Start Your 14-Day Trial"
      description="Ready to see LaunchDarkly's feature management platform in action? Tell us how you want your team to incorporate feature management into your software development life cycle. Request a demo with one of our product experts here."
    />
    <div className="header-bg stars-bg is-clipped with-stars section">
      <canvas
        style={{
          width: '100vw',
          height: '666px'
        }}
      />
    </div>
    <div className="section is-large bg-dark bg-white">
      <div className="container content ">
        <div className="columns is-variable is-8">
          <div className="column">
            <h1 className="title">
              Start Your <span style={{ whiteSpace: 'nowrap' }}>14-Day Trial</span>
            </h1>
            <p className="text-large">
              Your 14-day trial begins as soon as you sign up. We'll get you started with a quick start guide within the
              app.
            </p>
            <p className="text-large">
              You'll see how easy it is to manage the whole feature lifecycle from concept to launch to control.
            </p>
          </div>
          <div className="column">
            <div className="card formCard">
              <Signup />
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterSmall />
  </Layout>
)

export default StartTrial
